import header from '../modules/header/index';
import blogsPagination from '../modules/blogsPagination';

jQuery(function () {
    header();
    blogsPagination();
})